import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=17915d5d"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports